import { render, staticRenderFns } from "./BaseSearchItem.vue?vue&type=template&id=6e35fd1b"
import script from "./BaseSearchItem.vue?vue&type=script&lang=js"
export * from "./BaseSearchItem.vue?vue&type=script&lang=js"
import style0 from "./BaseSearchItem.vue?vue&type=style&index=0&id=6e35fd1b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports